import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	headerCaptionForArchive: {
		id: 'inactive-projects-directory-base.header-caption-for-archive',
		defaultMessage: 'Archived projects',
		description: 'Page title for archive projects page',
	},
	headerCaptionForTrash: {
		id: 'inactive-projects-directory-base.header-caption-for-trash',
		defaultMessage: 'Trash',
		description: 'Page title for the "Trash" page.',
	},
});
